import React from 'react';
import IntegrationsCardView from '../view/IntegrationsCardView';

const IntegrationsCardEngine = ({ iconUrl, title, subTitle, actions }) => {
  const viewProps = { iconUrl, title, subTitle, actions };

  return <IntegrationsCardView {...viewProps} />;
};

export default IntegrationsCardEngine;
